import { Button, Box, Dialog, Typography } from "flux";
import { BaseDialogProps } from "@adora/shared/contexts/dialog-context";
import { Batch } from "@adora/shared/types/batch";

interface LoraTrainingDialogProps extends BaseDialogProps {
  batch: Batch;
}

const ViewLoraParamsDialog: React.FC<LoraTrainingDialogProps> = ({ batch, open, onClose }) => {
  const jsonBatchInfo: Record<string, string> = batch.info;
  return (
    <Dialog open={open} onClose={onClose} dataDogIdentifier="train custom lora parameters">
      <Box pb="8px">
        <Typography variant="h4">Parameters</Typography>

        <Box pb="8px">
          <Typography variant="subtitle1">Batch Name</Typography>
          <Typography variant="body2">{`${batch.name}`}</Typography>
        </Box>
        {jsonBatchInfo &&
          Object.entries(jsonBatchInfo).map(([key, value]) => (
            <Box key={key} pb="8px">
              <Typography variant="subtitle1">{key}</Typography>
              <Typography variant="body2">{`${value}`}</Typography>
            </Box>
          ))}
      </Box>

      <Box pb="8px">
        <Button
          variant="contained"
          onClick={() => onClose(true)}
          dataDogIdentifier="train custom lora parameters close"
        >
          Close
        </Button>
      </Box>
    </Dialog>
  );
};

export default ViewLoraParamsDialog;
